<script context="module" lang="ts">
  import { writable } from 'svelte/store';

  const activeId = writable(null);
  let id = 0;
</script>

<script lang="ts">
  import { slide } from 'svelte/transition';
  import type { Item } from '../types';

  export let title: Item['title'], description: Item['description'];

  const componentId = id++;

  $: active = $activeId === componentId;

  function setActive() {
    if ($activeId === componentId) {
      $activeId = null;
    } else {
      $activeId = componentId;
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="qa-item" class:opened={active} on:click={setActive}>
  <div class="question">
    <p class="text">{@html title?.value}</p>
    <button aria-label="Question">
      <svg
        class="rotateSvg"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16.293 9.29297L12 13.586L7.70703 9.29297L6.29303 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
          fill="#111111"
          fill-opacity="0.64"
        />
      </svg>
    </button>
  </div>
  {#if active}
    <div class="answer" transition:slide>
      <p class="text">
        {@html description?.value}
      </p>
    </div>
  {/if}
</div>
